import { render, staticRenderFns } from "./MostNeededTrainings.vue?vue&type=template&id=06e558f0&scoped=true"
import script from "../../../scripts/partials/dashboard-charts/MostNeededTrainings.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/dashboard-charts/MostNeededTrainings.js?vue&type=script&lang=js&external"
import style0 from "./MostNeededTrainings.vue?vue&type=style&index=0&id=06e558f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e558f0",
  null
  
)

export default component.exports